'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FlightLogoNumber(props) {
  var components = props.components,
      carrierCode = props.carrierCode,
      logoUrl = props.logoUrl;

  var styleFlightNumberLabel = (0, _emailStyleTools.textStyles)(components, 'FlightNumberLabel');
  var number = props.number;

  number = number || '0000';
  var carrierLogo = void 0;
  if (logoUrl) {
    carrierLogo = logoUrl;
  } else {
    if (carrierCode) {
      carrierLogo = 'https://smartpointprivate.wspan.com/SharedServices/Images/AirlineImages/LogoAirBig' + carrierCode + '.gif';
    } else {
      carrierLogo = 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/air.png';
    }
  }

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'FlightLogoNumber' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0', textAlign: 'center' } },
          _react2.default.createElement('img', { src: carrierLogo, alt: 'logo' })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0', textAlign: 'center' } },
          _react2.default.createElement(
            'span',
            { style: styleFlightNumberLabel },
            '' + carrierCode + number
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(FlightLogoNumber);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/FlightLogoCarrierNumber.jsx
// module id = 649
// module chunks = 0